"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePolicies = void 0;
exports.resolvePolicies = {
    when: {
        LAZY: 'LAZY',
        EAGER: 'EAGER',
    },
    async: {
        WAIT: 'WAIT',
        NOWAIT: 'NOWAIT',
    },
};
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib/resolve/interface.js
// module id = 422
// module chunks = 0